module.exports = __webpack_public_path__ + "static/Apercu-Medium-7bbdc2e3d51fb48b83a4d3a4a757a263.otf";